import { ButtonLink, Grid, GridItem, Heading, Picture, SignupButton, TypographyV2 as Typography } from '@which/seatbelt';
import { ChevronRightIcon } from '@which/seatbelt/src/components/Icons/Navigational/ChevronRight';
import classnames from 'classnames';
import { pushDataLayerClick } from '../../shared/utils';
import styles from './CommercialToolCTA.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CommercialToolCTA = _ref => {
  let {
    image,
    overlineText,
    title,
    description,
    linkText,
    linkUrl = '',
    backgroundColour,
    buttonType,
    toolName,
    itemGroup
  } = _ref;
  return /*#__PURE__*/_jsx("aside", {
    "aria-label": `${overlineText} action`,
    className: classnames(styles.commercialToolCTA, backgroundColour && styles[`commercialToolCTA--${backgroundColour}`]),
    "data-testid": "commercial-tool-cta",
    children: /*#__PURE__*/_jsxs(Grid, {
      className: styles.commercialToolCTAGrid,
      children: [/*#__PURE__*/_jsxs(GridItem, {
        className: styles.commercialToolCTAContentWrapper,
        columnStart: {
          medium: 1,
          large: 1
        },
        span: {
          medium: 8,
          large: 8
        },
        children: [/*#__PURE__*/_jsx(Heading, {
          heading: title,
          headingTag: "h2",
          headingType: "large",
          overline: overlineText
        }), /*#__PURE__*/_jsx(Typography, {
          textStyle: "sb-text-body-default-regular",
          children: description
        }), buttonType === 'signUp' ? /*#__PURE__*/_jsx(SignupButton, {
          href: linkUrl,
          onClick: () => onCtaClick(toolName, itemGroup, 'Subscribe to Which?')
        }) : /*#__PURE__*/_jsx("div", {
          className: styles.commercialToolCTAButtonWrapper,
          children: /*#__PURE__*/_jsxs(ButtonLink, {
            appearance: "secondary",
            href: linkUrl,
            onClick: () => onCtaClick(toolName, itemGroup, linkText),
            children: [/*#__PURE__*/_jsx(ChevronRightIcon, {}), linkText]
          })
        })]
      }), image && /*#__PURE__*/_jsx(GridItem, {
        className: styles.commercialToolCTAImageWrapper,
        columnStart: {
          medium: 9,
          large: 9
        },
        span: {
          medium: 4,
          large: 4
        },
        children: /*#__PURE__*/_jsx(Picture, {
          ...image,
          aspectRatioMain: "one-to-one",
          "data-testid": "commercial-cta-image",
          height: "285",
          src: image.src,
          width: "285"
        })
      })]
    })
  });
};

///////// IMPLEMENTATION /////////

const onCtaClick = function (toolName, itemGroup) {
  let linkText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return pushDataLayerClick({
    toolInfo: {
      name: toolName,
      category: itemGroup
    },
    itemText: `${linkText.toLowerCase()} (onward journey - commercial cta)`
  });
};